import type { CityIndexEntry } from "./types.js";

const earthRadiusKilometres = 6_371;

function degreesToRadians(value: number): number {
  return (value * Math.PI) / 180;
}

export function distanceBetweenKilometres(from: [number, number], to: [number, number]): number {
  const fromLongitude = degreesToRadians(from[0]);
  const fromLatitude = degreesToRadians(from[1]);
  const toLongitude = degreesToRadians(to[0]);
  const toLatitude = degreesToRadians(to[1]);
  const latitudeDelta = toLatitude - fromLatitude;
  const longitudeDelta = toLongitude - fromLongitude;
  const haversine =
    Math.sin(latitudeDelta / 2) ** 2 +
    Math.cos(fromLatitude) * Math.cos(toLatitude) * Math.sin(longitudeDelta / 2) ** 2;

  return 2 * earthRadiusKilometres * Math.asin(Math.sqrt(haversine));
}

export function closestCity(
  coordinates: [number, number],
  cities: readonly CityIndexEntry[],
): CityIndexEntry | undefined {
  return cities.reduce<CityIndexEntry | undefined>((closest, city) => {
    if (!closest) return city;
    return distanceBetweenKilometres(coordinates, city.center) <
      distanceBetweenKilometres(coordinates, closest.center)
      ? city
      : closest;
  }, undefined);
}
